import { Component } from '@angular/core';
import { NavController, ViewController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

//Providers
import { SBSuiteManager } from '../../modules/sbsuite/providers/sbsuite.manager';
//Models
import { ClockIn } from '../../modules/sbsuite/models/clock-in.model';


/**
 * Componente Modal para la selección de operaciones
 *
 * @export
 * @class OperationModal
 */
@Component({
  selector: 'page-operation-modal',
  templateUrl: 'operation.modal.html'
})
export class OperationModal {

  /**
   * Array seleccionable con los datos de las operaciones relacionadas.
   *
   * @type {Array<any>}
   * @memberof OperationModal
   */
  operations: Array<any> = [];

  /**
   * Fichada objectivo a tratar.
   *
   * @type {ClockIn}
   * @memberof OperationModal
   */
  clockIn: ClockIn = new ClockIn();


  /**
   * Crea una instancia de OperartionsModal:
   *  - Assigna la fichada a partir de los NavParams.
   *  - Prepara el array de operaciones seleccionables.
   * 
   * @param {NavParams} _navParams
   * @param {NavController} navCtrl
   * @param {ViewController} viewCtrl
   * @param {SBSuiteManager} sbSuiteManager
   * @param {TranslateService} translateService
   * @memberof OperationModal
   */
  constructor(
    private _navParams: NavParams,
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public sbSuiteManager: SBSuiteManager,
    public translateService: TranslateService
  ) {

    this.clockIn = this._navParams.get('data');
    let operations = [];

    try{
      operations = this.clockIn.getRelatedOperations();
    }catch(e){
      console.warn('Bad nav parameter on Operation Modal', e);
    };

    if(operations){
      this.operations = operations.map(operation=>{
        let extOp = {
          code: operation.code,
          name: operation.name,
          product: operation.product,
          selected: false
        }
        return extOp;
      });
    }
    else{
      this.operations = this.sbSuiteManager.sbSuite.clocking.getMockOperations().map(operation=>{
        let extOp = {
          code: operation.code,
          name: operation.desc,
          selected: false
        }
        return extOp;
      });
    } 
  }


  /**
   * Selecciona la operación actual para la fichada
   *
   * @param {number} index
   * @memberof OperationModal
   */
  selectOperation(index: number){
    this.clockIn.operation = this.operations[index];
    this.viewCtrl.dismiss({clockIn: this.clockIn});
  }

  /**
   * Cierra el modal sin selección
   *
   * @memberof OperationModal
   */
  dismiss(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/operation/operation.modal.ts